/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_P1Inputs */

const en_wc_tut_ui_p1 = /** @type {(inputs: Wc_Tut_Ui_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ribbon has the same tabs as Word. Each tab groups related commands:`)
};

/**
* | output |
* | --- |
* | "The ribbon has the same tabs as Word. Each tab groups related commands:" |
*
* @param {Wc_Tut_Ui_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_p1 = /** @type {((inputs?: Wc_Tut_Ui_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_p1(inputs)
});
export { wc_tut_ui_p1 as "wc.tut.ui.p1" }